type EntitlementFeature = {
  code?: string;
  quantity?: number;
};

export const hasEntitlementFeature = (
  features: EntitlementFeature[] | undefined,
  featureCode: string
): boolean => {
  if (!features?.length) return false;

  return features.some(
    (feature) =>
      feature.code?.toLowerCase() === featureCode.toLowerCase() && (feature.quantity ?? 0) > 0
  );
};
